import { TabsService } from 'src/app/shared/components/tabs/tabs.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AgGridColumnsSettingService } from './ag-grid-columns-setting.service';
import { AgGridService } from '../ag-grid/ag-grid.service';
import { ColDef, ColumnApi, GridApi, RowDragLeaveEvent } from 'ag-grid-community';
import { SidebarCellComponent } from './sidebar-cell/sidebar-cell.component';
// import { TabsService } from '../tabs/tabs.service';
import { StorageService } from '../../services/storage.service';
import {  UserSetting } from 'src/app/components/crm/crm.model';
import {GridName} from '../../../shared/model/ag-grid-common-constant'

import { AgGridI, SaveUserSetting } from '../ag-grid/ag-grid.model';
import { DisplayName } from '../../model/enum';
import { Subscription } from 'rxjs/internal/Subscription';
import { takeUntil } from 'rxjs';
declare var window: any;

@Component({
  selector: 'app-ag-grid-columns-setting',
  templateUrl: './ag-grid-columns-setting.component.html',
  styleUrls: ['./ag-grid-columns-setting.component.scss']
})
export class AgGridColumnsSettingComponent implements OnInit {
  enumParams = DisplayName;
  customizer: string = "";
  sidebarGridApi!: GridApi;
  sidebarGridColumnApi: ColumnApi;
  initialSideRowData: any[] = [];
  sideRowData: any[] = [];
  userSetting = new UserSetting();
  saveUserSetting = new SaveUserSetting();
  gridName = GridName
  indexToSKip = 2;
  isClosed = false;
  searchData: string = '';
  gridData;
  @Input() storageName;

  public sideColumnDefs: ColDef[] = [
    {
      field: "columns",
      cellRenderer: SidebarCellComponent,
      // rowDrag: true,
      rowDrag: function (params) {
      if (params.data.columns === DisplayName.COMPANY && params.data.uniqueName === 'reqCompanyName') {
        return true;
      }
        return params.data.columns != "Req No" && params.data.columns != "Company" && params.data.columns != 'Full Name' && params.data.columns != 'Contact Name'&& params.data.columns != 'Vendor Contact Name'  && params.data.uniqueName != 'vendorName' 
        && params.data.uniqueName != 'mpn' && params.data.uniqueName != 'partNumber' && params.data.uniqueName != 'pendingStatus'  && 
        params.data.columns != DisplayName.ALLOCATED_QTY && params.data.columns != DisplayName.CONSIGNED_QTY &&  params.data.uniqueName != 'status' 
        && params.data.uniqueName != DisplayName.DATEOFFERED
        && params.data.uniqueName != 'approved'
        && params.data.uniqueName != 'historyMessage'  
        && params.data.uniqueName != 'certificationName'
        &&  params.data.uniqueName != 'offerStatus'
        &&  params.data.uniqueName != 'listDate'
        &&  params.data.uniqueName != 'alternativeMpn'
        &&  params.data.uniqueName !='workOrdercompanyName'
        &&  params.data.uniqueName !='files'
        &&  params.data.uniqueName != 'priority'
        &&  params.data.uniqueName != 'relatedReqMpn'
        &&  params.data.uniqueName != 'reqNo'
      },
    }
  ];
  
  // public sideDefaultColDef: ColDef = {
  //   width: 170,
  //   autoHeight: true,
  //   sortable: true,
  //   filter: true,
  // };

  // //#endregion

  public icons: {
    [key: string]: Function | string;
  } = {
      rowDrag: ` <img 
    src="./assets/SVGIcons/Gridicon.svg" 
    alt="" 
    width="13" 
    height="12">`,
    };
  // overlayNoRowsTemplate = '<div class="ag-overlay-no-rows-center">No Records Available</div>';
  @Input() dataModel: any;
  settingColumns:any[];
  searchTerm: string = '';
  childFields: any=[];
  filteredColumns: any[];
  hideColumnsPermanentSubscription: Subscription;
  constructor(
    public agGridService: AgGridService,
    public tabService: TabsService,
    public storageService: StorageService,
    public agGridColumnsSettingService: AgGridColumnsSettingService,
  ) { }

  sideOnGridReady(event){
    this.sidebarGridApi = event.api;
    this.sidebarGridColumnApi = event.columnApi;
    this.getUpdatedColumnDefination();
  }

  ngOnInit(): void {
    this.storageName
   this.gridData =  this.dataModel;
   this.agGridService.onColumnDragStopped.subscribe((event) => {
    if(event){ this.getUpdatedColumnDefination(); }
   })

    // this.agGridService.dataInput.subscribe((res =>{
    //   if(res){
    //  //   this.dataModel = res;
    //     this.storagePath = res;
    //  }
    // }))
    this.agGridColumnsSettingService.sidebarRow.subscribe((res) => {
      if(res)
      this.hideShowColumns(res[0].checked, res[0].name);
    });

    this.agGridColumnsSettingService.isCustomizerLayoutOpen.subscribe(
      (res) => {
        if (res.storageName === this.storageName) {
          this.customizer = res.state;
          if (res.state === 'layout') {
            this.isClosed = false;
          }
        }
      }
    );
    if (this.storageName === this.gridName.CONTACTRECYCLE || this.storageName == this.gridName.CONTACTS) {
      this.indexToSKip = 1;
    }
    if (this.storageName == this.gridName.VENDORLISTS) {
      this.indexToSKip = 3;
    }
    if (this.storageName === this.gridName.REQUIREMENTS) {
      this.indexToSKip = 0;
    }

  }
//   //#region getupdatedColumnDefination
  getUpdatedColumnDefination() {
    let columnsData
   // let columnsData = this.dataModel?.columnApi?.getAllDisplayedColumns();
   let a =this.gridData?.columnApi?.getAllDisplayedColumns();
   columnsData =this.gridData?.columnApi?.getAllGridColumns();
   //  var columnsData = this.agGridService.getGridColumnApi().getAllGridColumns();
    this.setColDefinationToRows(columnsData);
  }
//   //#endregion

//   //#region setColDefinationToRows
  setColDefinationToRows(value) {
    if (value != null) var columns = value;
    else columns = this.gridData?.columnApi?.getAllGridColumns();
    //this.agGridService.getGridColumnApi().getColumns();
     var sideRowData1: any[] = [];

    columns.map((item) => {
        return {
          columns: item.colDef.headerName,
          checked: item.visible,
          uniqueName: item.colDef.uniqueName
        };
      })
      .forEach((item) => sideRowData1.push(item));
    this.sideRowData = sideRowData1.filter(
      (item) =>
        item.columns != undefined &&
        item.columns != "" &&
        item.columns != "Icons"
    );
    this.initialSideRowData = sideRowData1.filter(
      (item) =>
        item.columns != undefined &&
        item.columns != "" &&
        item.columns != "Icons"
    );
  }
//   //#endregion
  onFilterTextBoxChanged() {
    this.searchData = (document.getElementById("filter-text-box") as HTMLInputElement).value;
    if (!this.searchData) {
      this.resetToDefault(false);
    } else {
      this.getUpdatedColumnDefination();
      this.sideRowData = this.initialSideRowData.filter((value) => {
        return value.columns?.toLowerCase().startsWith(this.searchData?.toLowerCase());
      });
    }
  }

  onRowDragLeave(event: RowDragLeaveEvent) {
    this.resetToDefault(false);
    if (this.searchData) {
      this.sideRowData = this.initialSideRowData.filter((value) => {
        return value.columns?.toLowerCase().startsWith(this.searchData?.toLowerCase());
      });
    }
  }

  onRowDragEnd(event: RowDragLeaveEvent) {
    let isSearched = false;
    let name = event.overNode.data.columns;
    let eventValue = event.overIndex + 1;
    let eventValue1 = event.overIndex - 2;
    if ((this.searchData.includes('c') || this.searchData.includes('C')) && this.storageName != this.gridName.CONTACTS) {
      isSearched = true
    }
    if ((this.searchData.includes('f') || this.searchData.includes('F')) && this.storageName == this.gridName.CONTACTS) {
      isSearched = true
    }
    if (this.searchData) {
      if (name != "Company" && name != "Req No" && name != 'MPN' && name !='Part Number' && event.overIndex == 0 && this.storageName != this.gridName.CONTACTS && isSearched || name != 'Full Name' && event.overIndex == 0 && this.storageName == this.gridName.CONTACTS && isSearched) {
        this.resetToDefault(false);
      } else {
        if (event.overIndex == 0) {
          this.indexToSKip = 3
        } else {
          this.indexToSKip = 2
        }
        this.gridData?.columnApi?.columnModel?.moveColumn(this.getSidebarFeilds(name), event.overIndex + this.indexToSKip);
      }
    } else {
      switch (this.storageName) {
        case this.gridName.COMPANYRECYCLE:
        case this.gridName.COMPANIES:
        case this.gridName.LEADS:
        case this.gridName.PROSPECTS:
        case this.gridName.CUSTOMERS:
          this.gridData?.columnApi?.columnModel?.moveColumn(this.getSidebarFeilds(name), eventValue + this.indexToSKip);
          break;
      
        case this.gridName.HISTORY:
        case this.gridName.CERTIFICATION:
        case this.gridName.VENDORCONTACTS:
        case this.gridName.PARTLIST:
        case this.gridName.INSTOCK:
        case this.gridName.ALLOCATION:
        case this.gridName.PENDING:
        case this.gridName.QUARANTINE:
        case this.gridName.CONSIGNMENT:
        case this.gridName.OFFERS:
        case this.gridName.OEM_EXCESS:
        case this.gridName.VENDOR_PARTS:
        case this.gridName.ALTERNATIVES:
        case this.gridName.REQUIREMNT:
        case this.gridName.WORKORDER:
        case this.gridName.FILES:
        case this.gridName.DOCUMENT:
          const columnModel = this.gridData?.columnApi?.columnModel;
          columnModel.moveColumn(this.getSidebarFeilds(name), eventValue1 + this.indexToSKip);
          break;
        case this.gridName.VENDOR_PARTS_LIBRARY:
        case this.gridName.OEM_EXCESS_MANAGER:
          this.indexToSKip = 0
          this.gridData?.columnApi?.columnModel?.moveColumn(this.getSidebarFeilds(name), event.overIndex  + this.indexToSKip);
          break;
        default:
          if (
            (name !== "Company" && name !== "Req No" && name !== "MPN" && name !== "Part Number" && event.overIndex === 0 && this.storageName !== this.gridName.CONTACTS) || 
            (name !== "Full Name" && event.overIndex === 0 && this.storageName === this.gridName.CONTACTS)
          ) {
            this.resetToDefault(false);
          } else {
            this.gridData?.columnApi?.columnModel?.moveColumn(this.getSidebarFeilds(name), event.overIndex + this.indexToSKip);
          }
          break;
      }
      
    }
    this.updateUserSetting();
    this.getAllRows()
  }



  getAllRows() {
    // let rowData = [];
    // this.sidebarGridApi?.forEachNode(node => rowData.push(node.data));
    // if (this.sideRowData.length < rowData.length) {
         this.resetToDefault(false);
    // }
}

  updateUserSetting() {
    // this.sideRowData =  Array.from(new Set(this.sideRowData));
    //const data = this.gridData?.columnApi?.columnModel?.columnDefs;
    const grid =  this.gridData?.columnApi?.columnModel?.gridColumns;
     if (!Array.isArray(grid) || grid.length === 0) {
    console.warn("No grid columns found");
    return null;
  }
    const filteredColumns = grid.filter((column) => column?.colDef).map((column) => column.colDef); 
    const data = filteredColumns;
   // const data = this.agGridService.getGridApi().getColumnDefs();
    this.userSetting = this.storageService.retrieve("userSetting")
    if (this.storageName == this.gridName.LEADS) {
      this.userSetting.leads = data.map((a: any, index: number) => {
        return { name: a.field == undefined ? '' : a.field, index: index + 1 }
      })
    }
    if (this.storageName == this.gridName.COMPANIES) {
      this.userSetting.companies = data.map((a: any, index: number) => {
        return { name: a.field == undefined ? '' : a.field, index: index + 1 }
      })
    }
    if (this.storageName == this.gridName.CUSTOMERS) {
      this.userSetting.customers = data.map((a: any, index: number) => {
        return { name: a.field == undefined ? '' : a.field, index: index + 1 }
      })
    }
    if (this.storageName == this.gridName.PROSPECTS) {
      this.userSetting.prospects = data.map((a: any, index: number) => {
        return { name: a.field == undefined ? '' : a.field, index: index + 1 }
      })
    }
    if (this.storageName == this.gridName.CONTACTS) {
      this.userSetting.contacts = data.map((a: any, index: number) => {
        return { name: a.field == undefined ? '' : a.field, index: index + 1 }
      })
    }
    if (this.storageName == this.gridName.VENDORLISTS) {
      this.userSetting.vendorLists = data.map((a: any, index: number) => {
        return { name: a.field == undefined ? '' : a.field, index: index + 1 }
      })
    }
    if (this.storageName == this.gridName.CONTACTRECYCLE) {
      this.userSetting.contactRecycle = data.map((a: any, index: number) => {
        return { name: a.field == undefined ? '' : a.field, index: index + 1 }
      })
    }
    if (this.storageName == this.gridName.COMPANYRECYCLE) {
      this.userSetting.companiesRecycle = data.map((a: any, index: number) => {
        return { name: a.field == undefined ? '' : a.field, index: index + 1 }
      })
    }
    if (this.storageName == this.gridName.REQUIREMENTS) {
      this.userSetting.requirementLists = data.map((a: any, index: number) => {
        return { name: a.field == undefined ? '' : a.field, index: index + 1 }
      })
    }
    if (this.storageName == this.gridName.PARTLIST) {
      this.userSetting.partlists = data.map((a: any, index: number) => {
        return { name: a.field == undefined ? '' : a.field, index: index + 1 }
      })
    }
    if (this.storageName == this.gridName.INSTOCK) {
      this.userSetting.instocks = data.map((a: any, index: number) => {
        return { name: a.field == undefined ? '' : a.field, index: index + 1 }
      })
    }
    if (this.storageName == this.gridName.ALLOCATION) {
      this.userSetting.allocations = data.map((a: any, index: number) => {
        return { name: a.field == undefined ? '' : a.field, index: index + 1 }
      })
    }
    if (this.storageName == this.gridName.PENDING) {
      this.userSetting.pendings = data.map((a: any, index: number) => {
        return { name: a.field == undefined ? '' : a.field, index: index + 1 }
      })
    }
    if (this.storageName == this.gridName.QUARANTINE) {
      this.userSetting.quarantine = data.map((a: any, index: number) => {
        return { name: a.field == undefined ? '' : a.field, index: index + 1 }
      })
    }
    if (this.storageName == this.gridName.CONSIGNMENT) {
      this.userSetting.consigment = data.map((a: any, index: number) => {
        return { name: a.field == undefined ? '' : a.field, index: index + 1 }
      })
    }
    if (this.storageName == this.gridName.HISTORY) {
      this.userSetting.history = data.map((a: any, index: number) => {
        return { name: a.field == undefined ? '' : a.field, index: index + 1 }
      })
    }
    const mappings: Record<string, keyof typeof this.userSetting> = {
      [this.gridName.VENDOR_PARTS_LIBRARY]: 'vendorPartsLibrary',
      [this.gridName.OEM_EXCESS_MANAGER]: 'oemExcessManager',
      [this.gridName.OFFERS]: 'offers',
      [this.gridName.OEM_EXCESS]: 'oemExcess',
      [this.gridName.VENDOR_PARTS]: 'vendorParts',
      [this.gridName.ALTERNATIVES]: 'alternatives',
      [this.gridName.REQUIREMNT]: 'requirement',
      [this.gridName.WORKORDER]: 'workOrder',
      [this.gridName.FILES]: 'files',
      [this.gridName.DOCUMENT] : 'document'
    };
    
    if (this.storageName in mappings) {
      this.userSetting[mappings[this.storageName]] = data.map((a: any, index: number) => ({
        name: a.field ?? '',
        index: index + 1
      }));
    }
    this.saveUserSetting.userSetting = JSON.stringify(this.userSetting);
    this.agGridService.saveUserSetting(this.saveUserSetting).subscribe(res => {
      const json = JSON.parse(res?.response);
      this.storageService.store("userSetting", json)
    });

    if (this.gridData?.columnApi) {
      const rawState = this.gridData.columnApi.getColumnState();
      const cleanState = rawState.map(col => {
        const column = this.gridData.columnApi.getColumn(col.colId);
        const colDef = column?.getColDef();
        let flexVal = col.flex;
        if ((flexVal === undefined || flexVal === null) && colDef && colDef.flex !== undefined && colDef.flex !== null) {
          flexVal = colDef.flex;
        }
        return {
          ...col,
          flex: (flexVal !== undefined && flexVal !== null) ? flexVal : null,
        };
      });
      this.agGridColumnsSettingService.columnOrderChanged.next({
        storageName: this.storageName,
        columnState: cleanState
      });
    }
  }

getSidebarFeilds(name: string) {
  const columnDefs = this.gridData?.columnApi?.columnModel?.columnDefs;

  if (!Array.isArray(columnDefs) || columnDefs.length === 0) {
    console.warn("No column definitions found");
    return null;
  }

  const headerNameList = columnDefs.map(item => ({
    headerName: item.headerName,
    field: item.field,
  }));

  const match = headerNameList.find(a => a.headerName === name);
  return match ? match.field : null;
}


  resetToDefault(isResetButtonClicked) {
    this.searchData = '';
    if (isResetButtonClicked) {
      (document.getElementById("filter-text-box") as HTMLInputElement).value = "";
    // this.agGridService.getGridColumnApi().resetColumnState();
     this.gridData?.columnApi?.resetColumnState();
      this.setColDefinationToRows(null);
      // this.initialSideRowData.map(data => data.checked = true);
      switch (this.storageName) {
        case this.gridName.VENDORLISTS:
          return this.isVendorListConditionMet();
      
        case this.gridName.COMPANYRECYCLE:
        case this.gridName.COMPANIES:
          return this.isCompanyConditionMet();
      
        case this.gridName.LEADS:
          return this.isLeadConditionMet();
      
        case this.gridName.PROSPECTS:
          return this.isProspectConditionMet();
      
        case this.gridName.CONTACTRECYCLE:
        case this.gridName.CONTACTS:
        case this.gridName.VENDORCONTACTS:
          return this.isContactConditionMet();
      
        case this.gridName.REQUIREMENTS:
          return this.isRequirementConditionMet();

        case this.gridName.PARTLIST:
        return this.isPartlistConditionMet();
        case this.gridName.INSTOCK:
        return this.isInstockConditionMet();
        case this.gridName.ALLOCATION:
        return this.isAllocationConditionMet();
        case this.gridName.CONSIGNMENT:
        return this.isConsignmentConditionMet();
        case this.gridName.PENDING:
        case this.gridName.QUARANTINE:
        case this.gridName.SOLD:
        return this.isPendingConditionMet();
        case this.gridName.OFFERS:
        return this.isOfferConditionMet();
        case this.gridName.OEM_EXCESS:
        return this.isOEMExcessConditionMet();
        case this.gridName.VENDOR_PARTS:
        return this.isVendorPartConditionMet();
        case this.gridName.ALTERNATIVES:
        return this.isAlternativeConditionMet();
        case this.gridName.REQUIREMNT:
        case this.gridName.QUOTES:
        case this.gridName.SALESORDERS:
        case this.gridName.PURCHASEORDERS:
        case this.gridName.INVOICES:
        return this.isTrans_RequirementsConditionMet();
        case this.gridName.WORKORDER:
        case this.gridName.RMA:
        case this.gridName.RTV:
        case this.gridName.NCM:
        case this.gridName.INSPECTION:
        return this.isWorkorderConditionMet();
        case this.gridName.HISTORY:
        return this.isHistoryConditionMet();
        case this.gridName.FILES:
        return this.isFilesConditionMet();
        case this.gridName.VENDOR_PARTS_LIBRARY:
        return this.isVPLConditionMet();
        case this.gridName.OEM_EXCESS_MANAGER:
        return this.isOEMManagerConditionMet();
        case this.gridName.VENDOR_PARTS_LIST:
        return this.isVPLSubtabConditionMet();
        case this.gridName.REQUIREMENT_SOURCES_GRID:
          return this.isRequirementPriorityConditionMet();

        case this.gridName.RELATED_REQUIREMENT:
        return this.isRelatedRequirementConditionMet()

        case this.gridName.CERTIFICATION:
          return this.isCertificationConditionMet()
        case this.gridName.DOCUMENT:
          return this.isDocumentConditionMet();
        case this.gridName.REQUIREMENT_POTENTIAL_GRID:
          return this.isRequirementPotentialConditionMet();
        case this.gridName.REQUIREMENT_AVAILABLE_GRID:
          return this.isRequirementAvailableConditionMet();
        case this.gridName.SOURCING_REQUIREMENT:
        case this.gridName.SOURCING_BATCH_OVERVIEW:
          return this.isSourcingRequirementConditionMet();
        case this.gridName.SOURCING_POTENTIAL_GRID:
          return this.isSourcingPotentialConditionMet();
        case this.gridName.SOURCING_SEND_RFQS_GRID:
          return this.isSourcingSentRFQConditionMet();
        case this.gridName.SOURCING:
          return this.isSourcingResetconditionMet();
      
        default:
          return this.defaultList();
      }
      
  
    }
    else {
      this.getUpdatedColumnDefination();
    }
    if (this.storageName == this.gridName.CONTACTS && isResetButtonClicked || this.storageName == this.gridName.CONTACTRECYCLE && isResetButtonClicked) {
      this.sideRowData = [this.sideRowData[1], this.sideRowData[0], ...this.sideRowData.slice(2)];
    }
    this.sidebarGridApi?.setRowData([...this.initialSideRowData]);
    this.updateUserSetting();
  }

  hideShowDefaultColumns(initialSideRowData) {
    initialSideRowData.forEach((element: any) => {
     //this.agGridService.getGridColumnApi();
      this.gridData?.columnApi?.setColumnVisible(this.getSidebarFeilds(element.columns), element.checked);
  // this.sideRowData.map(value => {  
  //   if (value.columns == element.columns) {
  //     value.checked = element.checked
  //   }
  // })
    });
    const columnState =  this.gridData?.columnApi?.getColumnState();
    //this.agGridService.getGridColumnApi().getColumnState();
    this.storageService.store(this.storageName, columnState);
    

  }

  hideShowColumns(event, columnName) {
    if (!event) {
      //this.agGridService.getGridColumnApi().setColumnVisible(this.getSidebarFeilds(columnName), false);
      this.gridData?.columnApi?.setColumnVisible(this.getSidebarFeilds(columnName), false);
      this.sideRowData.map(value => {
        if (value.columns == columnName) {
          value.checked = false
        }
      })
     // const columnState = this.agGridService.getGridColumnApi().getColumnState();
      const columnState =  this.gridData?.columnApi?.getColumnState();
      this.storageService.store(this.storageName, columnState);
  
    } else {
     // this.agGridService.getGridColumnApi().setColumnVisible(this.getSidebarFeilds(columnName), true);
     this.gridData?.columnApi?.setColumnVisible(this.getSidebarFeilds(columnName), true);
      this.sideRowData.map(value => {
        if (value.columns == columnName) {
          value.checked = true
        }
      })
     // const columnState = this.agGridService.getGridColumnApi().getColumnState();
     const columnState = this.gridData?.columnApi?.getColumnState();
      this.storageService.store(this.storageName, columnState);
  
      this.sidebarGridApi?.setRowData([...this.sideRowData]);
      this.updateUserSetting();
   
    }
  }


  ngOnDestroy() {
    this.agGridColumnsSettingService.isCustomizerLayoutOpen.next({ state: '', storageName: this.storageName });
  }

  toggleColumnSetting() {
    this.isClosed = !this.isClosed;
    if (this.isClosed) {
      this.agGridColumnsSettingService.isCustomizerLayoutOpen.next({ state: '', storageName: this.storageName });
    }
  }
isPartlistConditionMet(){
    this.initialSideRowData.map(data => ( data.columns == this.enumParams.MPN ||
      data.columns == this.enumParams.MFR ||
      data.columns == this.enumParams.CONSIGNMENT ||
      data.columns == this.enumParams.OFFER 
    )? data.checked = true : data.checked = false);
    this.hideShowDefaultColumns(this.initialSideRowData)    
  }
isInstockConditionMet(){
    this.initialSideRowData.map(data => ( data.columns == this.enumParams.PARTNUMBER ||
      data.columns == this.enumParams.MFR ||
      data.columns == this.enumParams.ROHS ||
      data.columns == this.enumParams.DATECODE ||
      data.columns == this.enumParams.LOTCODE ||
      data.columns == this.enumParams.VENDOR 
    )? data.checked = true : data.checked = false);
    this.hideShowDefaultColumns(this.initialSideRowData)    
  }
  isAllocationConditionMet(){
    this.initialSideRowData.map(data => ( data.columns == this.enumParams.ALLOCATED_QTY ||
      data.columns == this.enumParams.DATECODE ||
      data.columns == this.enumParams.ROHS ||
      data.columns == this.enumParams.LOTCODE 
    )? data.checked = true : data.checked = false);
    this.hideShowDefaultColumns(this.initialSideRowData)    
  }
    isConsignmentConditionMet(){
    this.initialSideRowData.map(data => ( data.columns == this.enumParams.CONSIGNED_QTY ||
      data.columns == this.enumParams.MPN ||
      data.columns == this.enumParams.MFR ||
      data.columns == this.enumParams.ROHS ||
      data.columns == this.enumParams.DATECODE ||
      data.columns == this.enumParams.LOTCODE 
    )? data.checked = true : data.checked = false);
    this.hideShowDefaultColumns(this.initialSideRowData)    
  }
  isPendingConditionMet(){
    this.initialSideRowData.map(data => ( data.columns == this.enumParams.STATUS ||
      data.columns == this.enumParams.MPN ||
      data.columns == this.enumParams.MFR ||
      data.columns == this.enumParams.DATECODE ||
      data.columns == this.enumParams.LOTCODE ||
      data.columns == this.enumParams.QTY 
    )? data.checked = true : data.checked = false);
    this.hideShowDefaultColumns(this.initialSideRowData)    
  }
isOfferConditionMet(){
    this.initialSideRowData.map(data => ( data.columns == this.enumParams.STATUS ||
      data.columns == this.enumParams.MPN ||
      data.columns == this.enumParams.MFR ||
      data.columns == this.enumParams.DATECODE ||
      data.columns == this.enumParams.DATE_OFFERED 
    )? data.checked = true : data.checked = false);
    this.hideShowDefaultColumns(this.initialSideRowData)    
  }
  isOEMExcessConditionMet(){
    this.initialSideRowData.map(data => ( data.columns == this.enumParams.LISTDATE ||
      data.columns == this.enumParams.MPN ||
      data.columns == this.enumParams.MFR ||
      data.columns == this.enumParams.ROHS ||
      data.columns == this.enumParams.CUSTOMERCONTACT ||
      data.columns == this.enumParams.CUSTOMER ||
      data.columns == this.enumParams.EXPIRATIONDATE 
    )? data.checked = true : data.checked = false);
    this.hideShowDefaultColumns(this.initialSideRowData)    
  }
isVendorPartConditionMet(){
     this.initialSideRowData.map(data => ( data.columns == this.enumParams.LISTDATE ||
      data.columns == this.enumParams.MPN ||
      data.columns == this.enumParams.MFR ||
      data.columns == this.enumParams.ROHS ||
      data.columns == this.enumParams.VENDORCONTACT ||
      data.columns == this.enumParams.VENDOR ||
      data.columns == this.enumParams.EXPIRATIONDATE 
    )? data.checked = true : data.checked = false);
    this.hideShowDefaultColumns(this.initialSideRowData)    
  }

isAlternativeConditionMet(){
     this.initialSideRowData.map(data => ( data.columns == this.enumParams.MPN ||
      data.columns == this.enumParams.MANUFACTURER ||
      data.columns == this.enumParams.ROHS ||
      data.columns == this.enumParams.PARTSTATUS ||
      data.columns == this.enumParams.TAG ||
      data.columns == this.enumParams.STDPACKAGING 
    )? data.checked = true : data.checked = false);
    this.hideShowDefaultColumns(this.initialSideRowData)    
  }
isTrans_RequirementsConditionMet(){
     this.initialSideRowData.map(data => ( data.columns == this.enumParams.COMPANY ||
      data.columns == this.enumParams.STATUS ||
      data.columns == this.enumParams.QTY ||
      data.columns == this.enumParams.BUYTARGET ||
      data.columns == this.enumParams.CONTACT 
    )? data.checked = true : data.checked = false);
    this.hideShowDefaultColumns(this.initialSideRowData)    
  }
  isWorkorderConditionMet(){
     this.initialSideRowData.map(data => ( data.columns == this.enumParams.COMPNAME ||
      data.columns == this.enumParams.STATUSID ||
      data.columns == this.enumParams.WORKORDERID
    )? data.checked = true : data.checked = false);
    this.hideShowDefaultColumns(this.initialSideRowData)    
  }
isHistoryConditionMet(){
     this.initialSideRowData.map(data => ( data.columns == this.enumParams.EVENT ||
      data.columns == this.enumParams.ACTION ||
      data.columns == this.enumParams.BY ||
      data.columns == this.enumParams.MESSAGE
    )? data.checked = true : data.checked = false);
    this.hideShowDefaultColumns(this.initialSideRowData)    
  }
  isFilesConditionMet(){
     this.initialSideRowData.map(data => ( data.columns == this.enumParams.FILE_NAME ||
      data.columns == this.enumParams.CATEGORY ||
      data.columns == this.enumParams.TYPE
    )? data.checked = true : data.checked = false);
    this.hideShowDefaultColumns(this.initialSideRowData)    
  }
isVPLConditionMet(){
     this.initialSideRowData.map(data => ( data.columns == this.enumParams.MPN ||
      data.columns == this.enumParams.MANUFACTURER ||
      data.columns == this.enumParams.VENDOR ||
      data.columns == this.enumParams.VENDORCONTACT ||
      data.columns == this.enumParams.ROHS ||
      data.columns == this.enumParams.EXPIRATIONDATE ||
      data.columns == this.enumParams.RATING ||
      data.columns == this.enumParams.ACTIVE 
    )? data.checked = true : data.checked = false);
    this.hideShowDefaultColumns(this.initialSideRowData)    
  }
  isOEMManagerConditionMet(){
    this.initialSideRowData.map(data => ( data.columns == this.enumParams.MPN ||
      data.columns == this.enumParams.MANUFACTURER ||
      data.columns == this.enumParams.CUSTOMER ||
      data.columns == this.enumParams.CUSTOMERCONTACT ||
      data.columns == this.enumParams.ROHS ||
      data.columns == this.enumParams.EXPIRATIONDATE ||
      data.columns == this.enumParams.RATING ||
      data.columns == this.enumParams.ACTIVE 
    )? data.checked = true : data.checked = false);
    this.hideShowDefaultColumns(this.initialSideRowData)    
  }
isVPLSubtabConditionMet(){
    this.initialSideRowData.map(data => ( data.columns == this.enumParams.LISTDATE ||
      data.columns == this.enumParams.MPN ||
      data.columns == this.enumParams.MFR ||
      data.columns == this.enumParams.ROHS ||
      data.columns == this.enumParams.DATECODE
    )? data.checked = true : data.checked = false);
    this.hideShowDefaultColumns(this.initialSideRowData)    
  }
  isRequirementConditionMet(){
    this.initialSideRowData.map(data => ( data.columns == this.enumParams.REQUIREMENT ||
      data.columns == this.enumParams.REQDATE ||
      data.columns == this.enumParams.BUYTARGET ||
      data.columns == this.enumParams.TARGETPRICE ||
      data.columns == this.enumParams.STATUS ||
      data.columns == this.enumParams.PARTNUMBER ||
      data.columns == this.enumParams.CUSTOMERTARGET
    )? data.checked = true : data.checked = false);
    this.hideShowDefaultColumns(this.initialSideRowData)    
  }

  isVendorListConditionMet() {
       this.initialSideRowData.map(data => ( data.columns == this.enumParams.VENDOR_NAME ||
        data.columns === this.enumParams.Active ||
        data.columns === this.enumParams.RATING ||
        data.columns === this.enumParams.PHONE ||
        data.columns === this.enumParams.VENDORTYPE ||
        data.columns === this.enumParams.AVL ||
        data.columns === this.enumParams.QUICKNOTES
      )? data.checked = true : data.checked = false);
      this.hideShowDefaultColumns(this.initialSideRowData)    
  }
  isProspectConditionMet() {
    this.initialSideRowData.map(data => (data.columns == this.enumParams.COMPANY ||
      data.columns === this.enumParams.STAGE ||
      data.columns === this.enumParams.Active ||
      data.columns === this.enumParams.RATING ||
      data.columns === this.enumParams.TYPE ||
      data.columns === this.enumParams.PHONE ||
      data.columns === this.enumParams.INTENTTOBUY ||
      data.columns === this.enumParams.ALTERNATESALEPERSON ||
      data.columns === this.enumParams.DATECONTACTED ||
      data.columns === this.enumParams.DATECONTACTED ||
      data.columns === this.enumParams.REVENUE ||
      data.columns === this.enumParams.QUICKNOTES
   )? data.checked = true : data.checked = false);
   this.hideShowDefaultColumns(this.initialSideRowData)    

}
isLeadConditionMet() {
  this.initialSideRowData.map(data => (data.columns == this.enumParams.COMPANY ||
    data.columns === this.enumParams.STAGE ||
    data.columns === this.enumParams.Active ||
    data.columns === this.enumParams.RATING ||
    data.columns === this.enumParams.TYPE ||
    data.columns === this.enumParams.PHONE ||
    data.columns === this.enumParams.LEADSCORE ||
    data.columns == this.enumParams.SALEPERSON || 
    data.columns === this.enumParams.ALTERNATESALEPERSON ||
    data.columns === this.enumParams.DATECONTACTED ||
    data.columns === this.enumParams.REVENUE ||
    data.columns === this.enumParams.QUICKNOTES
 )? data.checked = true : data.checked = false);
 this.hideShowDefaultColumns(this.initialSideRowData)    

}
isCompanyConditionMet() {
  this.initialSideRowData.map(data => (data.columns == this.enumParams.COMPANY
 || data.columns == this.enumParams.RATING
 || data.columns == this.enumParams.Active
 || data.columns == this.enumParams.STAGE
 || data.columns == this.enumParams.TYPE
 || data.columns == this.enumParams.PHONE
 || data.columns == this.enumParams.DATECONTACTED
 || data.columns == this.enumParams.REVENUE
 || data.columns == this.enumParams.SALEPERSON
 || data.columns === this.enumParams.ALTERNATESALEPERSON 
 || data.columns === this.enumParams.QUICKNOTES
 )? data.checked = true : data.checked = false);
 this.hideShowDefaultColumns(this.initialSideRowData)    

}
defaultList() {
  this.initialSideRowData.map(data => (data.columns == this.enumParams.COMPANY
 || data.columns == this.enumParams.VENDOR_NAME
 || data.columns == this.enumParams.RATING
 || data.columns == this.enumParams.Active
 || data.columns == this.enumParams.STAGE
 || data.columns == this.enumParams.TYPE
 || data.columns == this.enumParams.PHONE
 || data.columns == this.enumParams.DATECONTACTED
 || data.columns == this.enumParams.REVENUE
 || data.columns === this.enumParams.QUICKNOTES
 )? data.checked = true : data.checked = false);
 this.hideShowDefaultColumns(this.initialSideRowData)    

}
isContactConditionMet() {
  this.initialSideRowData.map(data => (data.columns === this.enumParams.VENDORCONTACT_NAME ||
    data.columns === this.enumParams.RATING ||
    data.columns === this.enumParams.DEPARTMENT ||
    data.columns === this.enumParams.LOCATION ||
    data.columns === this.enumParams.TIMEZONE ||
    data.columns === this.enumParams.TITLE ||
    data.columns === this.enumParams.OFFICENUMBER ||
    data.columns === this.enumParams.DIRECTNUMBER ||
    data.columns === this.enumParams.MOBILENUMBER ||
    data.columns === this.enumParams.EMAILADDRESS ||
    data.columns === this.enumParams.DONOTCALL ||
    data.columns === this.enumParams.DONOTEMAIL ||
    data.columns === this.enumParams.LASTCONTACT ||
    data.columns === this.enumParams.COMPANYNAME ||
    data.columns === this.enumParams.Active ||
    data.columns === this.enumParams.NEXTTASKDUEDATE ||
    data.columns === this.enumParams.VENDOR_NAME

 )? data.checked = true : data.checked = false);
  this.hideShowDefaultColumns(this.initialSideRowData)    

}
  isCertificationConditionMet() {
    this.initialSideRowData.map(data => (data.columns == this.enumParams.CERTIFICATION_NAME ||
      data.columns == this.enumParams.FILE_NAME ||
      data.columns == this.enumParams.EXPIRATIONDATE
    ) ? data.checked = true : data.checked = false);
    this.hideShowDefaultColumns(this.initialSideRowData)
  }

  isDocumentConditionMet() {
    this.initialSideRowData.map(data=>(data.columns== this.enumParams.FILE_NAME ||
      data.columns == this.enumParams.TYPE)
      ? data.checked= true : data.checked = false);
    this.hideShowDefaultColumns(this.initialSideRowData)
  }

  isSourcesConditionMet(){
     this.initialSideRowData.map(data=>(data.columns== this.enumParams.PRIORITY ||
      data.columns == this.enumParams.DATE_OFFERED)
      ? data.checked= true : data.checked = false);
    this.hideShowDefaultColumns(this.initialSideRowData)
  }
  isRelatedRequirementConditionMet(){
    this.initialSideRowData.map(data=>(data.columns== this.enumParams.PARTNUMBER)
      ? data.checked= true : data.checked = false);
    this.hideShowDefaultColumns(this.initialSideRowData)
  }
  isSourcingConditionMet(){
    this.initialSideRowData.map(data=>(data.columns== this.enumParams.REQ_NO)
      ? data.checked= true : data.checked = false);
    this.hideShowDefaultColumns(this.initialSideRowData)
  }
  isRequirementPotentialConditionMet(){
    this.initialSideRowData.map(data=>(
      data.columns== this.enumParams.DATE_OFFERED ||
      data.columns== this.enumParams.STATUS ||
      data.columns== this.enumParams.PARTNUMBER
    )
      ? data.checked= true : data.checked = false);
    this.hideShowDefaultColumns(this.initialSideRowData)
  }
  isSourcingPotentialConditionMet(){
    this.initialSideRowData.map(data=>(
      data.columns== this.enumParams.DATE_OFFERED ||
      data.columns== this.enumParams.INCLUDE_IN_RFQ ||
      data.columns== this.enumParams.STATUS ||
      data.columns== this.enumParams.PARTNUMBER
    )
      ? data.checked= true : data.checked = false);
    this.hideShowDefaultColumns(this.initialSideRowData)
  }
  isRequirementAvailableConditionMet(){
    this.initialSideRowData.map(data=>(
      data.columns== this.enumParams.APPROVED ||
      data.columns== this.enumParams.STATUS ||
      data.columns== this.enumParams.PARTNUMBER
    )
      ? data.checked= true : data.checked = false);
    this.hideShowDefaultColumns(this.initialSideRowData)
  }
  isRequirementPriorityConditionMet(){
    this.initialSideRowData.map(data=>(
      data.columns== this.enumParams.PRIORITY ||
      data.columns== this.enumParams.STATUS ||
      data.columns== this.enumParams.PARTNUMBER
    )
      ? data.checked= true : data.checked = false);
    this.hideShowDefaultColumns(this.initialSideRowData)
  }
  isSourcingRequirementConditionMet(){
    this.initialSideRowData.map(data=>(
      data.columns== this.enumParams.REQ_NO ||
      data.columns== this.enumParams.MPN ||
      data.columns== this.enumParams.CUSTOMER ||
      data.columns== this.enumParams.CONTACT ||
      data.columns== this.enumParams.LINE_STATUS 
    )
      ? data.checked= true : data.checked = false);
    this.hideShowDefaultColumns(this.initialSideRowData)
  }
  isSourcingSentRFQConditionMet() {
    this.initialSideRowData.map(data => (
      data.columns == this.enumParams.VENDOR_NAME ||
      data.columns == this.enumParams.CONTACT ||
      data.columns == this.enumParams.RESULT ||
      data.columns === ''
    )
      ? data.checked = true : data.checked = false);
    this.hideShowDefaultColumns(this.initialSideRowData)
  }
   isSourcingResetconditionMet() {
    this.initialSideRowData.map(data => (
      data.columns == this.enumParams.SB_NO ||
      data.columns == this.enumParams.SALEPERSON ||
      data.columns == this.enumParams.READY_TO_QUOTE ||
      data.columns === this.enumParams.NO_BID
    )
      ? data.checked = true : data.checked = false);
    this.hideShowDefaultColumns(this.initialSideRowData)
  }
}
